<template>
  <div>
    <v-app-bar color="primary accent-4" dense dark fixed>

      <v-app-bar-nav-icon @click="changeMiniSidebar" class="d-none d-lg-block"></v-app-bar-nav-icon>
      <v-app-bar-nav-icon @click="changeMobileSidebar" class="d-lg-none"></v-app-bar-nav-icon>

      <a href="/#/dashboard" title="Dashboard" style="text-decoration: none;color: inherit;">
        <div style="display: flex; align-items: center">
          uCamp.it <img src="../../assets/logo.png" alt="uCamp.it" style="max-height: 35px"/>
        </div>
      </a>


      <v-spacer></v-spacer>

<!--      <v-btn icon>-->
<!--        <v-icon>mdi-heart</v-icon>-->
<!--      </v-btn>-->

<!--      <v-btn icon>-->
<!--        <v-icon>mdi-magnify</v-icon>-->
<!--      </v-btn>-->

      <template>
        <PushNotificationBell/>
      </template>

      <v-menu offset-y bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-avatar color="accent" size="38">
              <span class="white--text text-subtitle-1">{{ getAvatarShort(getUser.full_name) }}</span>
            </v-avatar>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item link dense to="/profile">
            <v-list-item-title><v-icon small class="mr-2">mdi-account</v-icon> {{ $t('profile') }}</v-list-item-title>
          </v-list-item>
          <v-list-item link dense>
            <a href="https://api.whatsapp.com/send/?phone=+393518531856&text=salve%20ho%20bisogno%20di%20aiuto%20su%20uCamp.it&type=phone_number&app_absent=0" target="_blank" title="Assistenza WhatsApp" style="text-decoration: none;color: inherit;">
              <v-list-item-title><v-icon small class="mr-2">mdi-whatsapp</v-icon> Assistenza WhatsApp</v-list-item-title>
            </a>
          </v-list-item>
          <v-list-item link dense>
            <a href="https://m.me/uCampPage" target="_blank" title="Assistenza Messenger" style="text-decoration: none;color: inherit;">
              <v-list-item-title><v-icon small class="mr-2">mdi-facebook-messenger</v-icon> Assistenza Messenger</v-list-item-title>
            </a>
          </v-list-item>
          <v-list-item link dense>
            <a href="https://linktr.ee/adminucamp" target="_blank" title="Tutorial" style="text-decoration: none;color: inherit;">
              <v-list-item-title><v-icon small class="mr-2">mdi-youtube</v-icon> Tutorial</v-list-item-title>
            </a>
          </v-list-item>
          <v-list-item link dense>
            <v-list-item-title @click="tryLogout"><v-icon small class="mr-2">mdi-logout</v-icon> {{ $t('logout') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import PushNotificationBell from "@/components/layout/NotificationBell.vue";

export default {
  name: "TopBar",
  components: {PushNotificationBell},
  methods: {
    ...mapActions({
      'logout': 'user/logout',
    }),
    ...mapMutations({
      'setMiniSidebar': 'settings/setMiniSidebar',
      'setMobileSidebar': 'settings/setMobileSidebar',
      'setLoading': 'settings/setLoading',
    }),
    async changeMiniSidebar(){
      await this.setMiniSidebar(!this.getMiniSidebar)
    },
    async changeMobileSidebar(){
      await this.setMiniSidebar(false)
      await this.setMobileSidebar(!this.getMobileSidebar)
    },
    async tryLogout() {
      this.setLoading(true)
      await this.logout()
      this.setLoading(false)
    },
    getAvatarShort(name){
      var split = name.split(' ')
      if(split.length > 1){
        return split[0].charAt(0)+split[1].charAt(0)
      }else {
        return name.charAt(0).toUpperCase()+name.charAt(1).toUpperCase()
      }
    },
  },
  computed: {
    ...mapGetters({
      'getMiniSidebar': 'settings/getMiniSidebar',
      'getMobileSidebar': 'settings/getMobileSidebar',
      'getUser': 'user/getUser',
    }),
  },
}
</script>

<style scoped>

</style>